import { AUTH_PROCESSING } from './actionType';

const initialState = {
    processing: false
};

const register = (state = initialState, action) => {
    switch (action.type) {
        case AUTH_PROCESSING:
            state = { ...state, processing: action.payload };
            break;

        default:
            state = { ...state };
            break;
    }
    return state;
};

export default register;
